import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/svgIcon/index";
import svgIcon from "@/svgIcon/index.vue";
import "./components/css/common.css"
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import VueI18n from './components/js/language';
const app = createApp(App)

app.use(store).use(router).use(VueI18n).use(ElementPlus).component('svg-icon', svgIcon).mount('#app')


